import { render } from "./CardsView.vue?vue&type=template&id=af0c934c"
import script from "./CardsView.vue?vue&type=script&lang=js"
export * from "./CardsView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rhylton/Sites/intranet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__